var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":function($event){$event.preventDefault();return _vm.toggleBookmark()}}},[_c('i',{staticClass:"fa-bookmark",class:{'fa-light': !_vm.isBookmarked, 'fa-solid': _vm.isBookmarked}})])
}
var staticRenderFns = []

export { render, staticRenderFns }